module.exports = __webpack_public_path__ + "static/media/PLAYGROUND_WORDMARK-S_WHITE_2.b6c48b1b.svg";